// hooks/useCostAmounts.js
import { useState } from "react";
import { InvoiceService } from "../../application/services/invoiceService";

const invoiceService = new InvoiceService();

export const useCostAmounts = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [costData, setCostData] = useState(null);

  const getCostAmounts = async (startMonth, startYear, endMonth, endYear) => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceService.getCostAmounts(startMonth, startYear, endMonth, endYear);
      if (result.success) {
        setCostData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getCostAmounts,
    costData,
    loading,
    error,
  };
};